import { useCallback, useEffect, useRef } from 'react';

import CheckoutSuccess from '@assets/success.json';
import { Button } from '@components/ui/button';
import { pages } from '@constants/pages';
import { useAuth } from '@contexts/auth';
import SessionService from '@services/sessions/SessionService';
import Lottie from 'react-lottie';
import { useNavigate } from 'react-router';

export function PaymentSuccess() {
  const { onSetUser } = useAuth();

  const navigate = useNavigate();

  const lottieRef = useRef<any>(null);

  const handleClose = useCallback(async () => {
    const userInfo = await SessionService.getInfo();
    onSetUser(userInfo);

    navigate(pages.home, { replace: true });
  }, [navigate, onSetUser]);

  useEffect(() => {
    setTimeout(() => {
      lottieRef.current?.play();
    }, 800);
  }, []);

  return (
    <div className="mx-auto flex max-w-2xl flex-col items-center justify-center">
      <h1 className="mb-6 text-center text-2xl font-normal md:text-3xl lg:my-10">
        Parabéns!
      </h1>

      <h1 className="text-center text-lg">
        Seu pagamento está em processamento e logo você terá acesso completo ao
        sistema!
      </h1>
      <Lottie
        height={380}
        isClickToPauseDisabled={true}
        options={{
          animationData: CheckoutSuccess,
          loop: false,
          autoplay: false,
        }}
        ref={lottieRef}
        speed={0.7}
        title="Não foi possível carregar"
        width={380}
      />

      <Button className="w-40 cursor-pointer" onClick={handleClose}>
        Fechar
      </Button>
    </div>
  );
}
